import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const TableWrapper = styled(Box)(({ theme }) => ({
	margin: '0 auto 2em',
	width: '100%',
	[theme.breakpoints.up('md')]: {
		width: '42em',
	},
}));

export default TableWrapper;
